<template>
  <MainLayout>
    <div>
      <v-row align="center">
        <v-col cols="2">
          <CancelButton :project-id="projectId" />
        </v-col>
        <v-col cols="8">
          <h1 style="text-align: center; margin-bottom: 10px;">Edit PSI</h1>
        </v-col>
      </v-row>
    <PsiForm
      v-model="form"
      :project-id="projectId"
      :psi-types="psiTypes"
      @submit="submit"
      class="ma-12"
    ></PsiForm>
  </div>
  </MainLayout>
</template>

<script setup>
import MainLayout from '@/Layouts/Main.vue'
import PsiForm from './Form.vue'
import {router} from "@inertiajs/vue3";
import * as $routes from "@/packs/routes";
import {ref} from "vue";
import CancelButton from "@/Shared/CancelButton.vue";

const props = defineProps({
  projectId: {
    type: Number,
    required: true
  },
  psiId: {
    type: Number,
    required: true
  },
  psi: {
    type: Object,
    required: true
  },
  psiTypes: {
    type: Array,
    required: true
  }
})

const form = props.psi
let confirmCancel = ref(false);

function submit() {
  router.put($routes.project_psi(props.projectId, props.psiId), form)
}
</script>

<style scoped>

</style>